import { Icon } from "@nju/icons";
import { IconName } from "@nju/icons";

interface IStatusBadgeProps {
  text: string | undefined;
  icon: IconName;
}

export function StatusBadge({ text, icon }: IStatusBadgeProps) {
  return (
    <div>
      <Icon className="mr-[8px]" height={18} name={icon} width={18} />
      {text}
    </div>
  );
}
